import { datatableFormaterStringified } from '@clickadilla/datatable-formatter';
import createMenuItemFromResource from '@/classes/createMenuGeneral';
import createMenuPayloadFromEditable from '@/classes/createMenuPayloadFromEditable';
import handleErrors from '@/services/handle-errors';
import http, { cancelTokenNames } from '../../http';
import urlFormatter from '../../url-formatter';

const getURL = urlFormatter({
  list: '/api/v1/admin/panel-menu-items',
  create: '/api/v1/admin/panel-menu-items',
  updateCustom: '/api/v1/admin/panel-menu-items/{id}',
  sort: '/api/v1/admin/panel-menu-items/sort',
  archive: '/api/v1/admin/panel-menu-items/{id}/archive',
  unarchive: '/api/v1/admin/panel-menu-items/{id}/unarchive',
});

export default {
  list() {
    const endpoint = getURL('list');

    return http.get(endpoint)
      .then((response) => response.data.data.map(createMenuItemFromResource));
  },
  async table({
    headers, options, search,
  }) {
    const requestBody = datatableFormaterStringified({
      headers,
      options,
      search,
    });
    const endpoint = getURL('list');
    const response = await http.get(`${endpoint}?${requestBody}`, {
      applyCancelAdapter: cancelTokenNames.MENU_GENERAL_TABLE,
    });

    return {
      items: response.data.data.map(createMenuItemFromResource),
      totalItemsCount: response.data.recordsFiltered,
    };
  },
  sort(menuItemsIds) {
    const endpoint = getURL('sort');

    return http.post(endpoint, {
      menu_items: menuItemsIds,
    })
      .catch((error) => handleErrors(error));
  },
  archive(id) {
    const endpoint = getURL('archive', { id });

    return http.post(endpoint)
      .catch((error) => handleErrors(error));
  },
  unarchive(id) {
    const endpoint = getURL('unarchive', { id });

    return http.post(endpoint)
      .catch((error) => handleErrors(error));
  },
  create(payload) {
    const endpoint = getURL('create');

    return http.post(endpoint, createMenuPayloadFromEditable(payload));
  },

  updateCustom(customId, payload) {
    const endpoint = getURL('updateCustom', { id: customId });

    return http.put(endpoint, createMenuPayloadFromEditable(payload));
  },
  getURL,
};
